/* eslint-disable react-hooks/exhaustive-deps */

import {
  Card,
  CardHeader,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Paper,
} from "@material-ui/core";
import {
  InputTextMaster,
  InputOptionMaster,
  MasterButton,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import { useDatatables } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState } from "react";
import { useEffect } from "react";
import { RESET_STATE_USER_ACCESS, useUserByRole } from "./helpers";

function TransferListUserAccess({ formData, setFormData, left, setLeft }) {
  const user = useUserByRole(formData.role_id);

  return (
    <Paper className='p-1 mt-1'>
      <Grid container spacing={3}>
        <Grid item sm={6}>
          <InputTextMaster
            name='id'
            label='ID'
            id='id'
            disabled={true}
            readOnly={true}
            placeholder='ID'
            value={formData.user_id}
          />
        </Grid>

        <Grid item sm={6}>
          <InputOptionMaster
            name='user_id'
            label='USER'
            id='user_id'
            withSearch={true}
            data={user}
            value={formData.user_id}
            labelValue={formData.user_name}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  user_id: null,
                  user_name: "Pilih User",
                });
              } else {
                setFormData({
                  ...formData,
                  user_id: e.value,
                  user_name: e.label,
                });
              }
            }}
          />
        </Grid>
      </Grid>

      <TransferListCard
        formData={formData}
        setFormData={setFormData}
        left={left}
        setLeft={setLeft}
      />
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
  },
  cardHeader: {
    fontSize: "12px",
  },
  list: {
    height: 400,
    backgroundColor: theme.palette.background.paper,
    overflow: "auto",
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
}));

const TransferListCard = ({ formData, setFormData, left, setLeft }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [right, setRight] = useState(formData.table);
  const handleToggle = (y) => {
    const modifiedLeft = left.filter((x) => x.table_id !== y.table_id);
    setLeft([...modifiedLeft]);
    setRight([
      ...right,
      {
        table_id: y.table_id,
        table_name: y.table_name,
      },
    ]);
  };

  const handleToggleRight = (y) => {
    const modifiedRight = right.filter((x) => x.table_id !== y.table_id);
    setRight([...modifiedRight]);
    setLeft([
      ...left,
      {
        table_id: y.table_id,
        table_name: y.table_name,
      },
    ]);
  };

  const totalData = parseInt(left.length) + parseInt(right.length);

  const handleSubmit = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.access_code) || isNull(formData.role_id)) {
        defaultToastError("Access dan Role tidak boleh kosong!");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else if (isNull(formData.user_id)) {
        defaultToastError("User tidak boleh kosong!");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        if (isNull(formData.id)) {
          const response = await instance2.post(
            "/users_access/create_users_access_bulk",
            {
              access_code: formData.access_code,
              user_id: formData.user_id,
              table: right,
            }
          );
          defaultToastSuccess(response.data.message);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        } else {
          const response = await instance2.post(
            "/users_access/update_users_access_bulk",
            {
              access_code: formData.access_code,
              user_id: formData.user_id,
              table: right,
            },
            {
              headers: {
                users_access_id: formData.user_id,
              },
            }
          );
          defaultToastSuccess(response.data.message);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        }
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    }
  };

  useEffect(() => {
    setRight(formData.table);
  }, [formData.user_id]);

  return (
    <Grid container spacing={3}>
      <Grid item sm={6}>
        <TransferListCardItem
          items={left}
          handleToggle={handleToggle}
          totalData={totalData}
          title='LIST DATA YANG BELUM TERPILIH'
        />
      </Grid>
      <Grid item sm={6}>
        <TransferListCardItem
          items={right}
          handleToggle={handleToggleRight}
          totalData={totalData}
          title='LIST DATA YANG SUDAH TERPILIH'
        />
      </Grid>

      <Grid item sm={12}>
        <MasterButton
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            padding: "0.8rem",
            fontSize: "16px",
          }}
          className='mb-1'
          type='button'
          onClick={(e) => handleSubmit(e)}
          color={disabled.color}
          disabled={disabled.state}
          name={disabled.label}
          size='md'
        />

        <MasterButton
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            padding: "0.5rem",
            fontSize: "16px",
          }}
          type='button'
          onClick={(e) => setFormData(RESET_STATE_USER_ACCESS)}
          color={"danger"}
          name={"Reset"}
          outline={true}
          size='md'
        />
      </Grid>
    </Grid>
  );
};

const TransferListCardItem = ({ handleToggle, items, title, totalData }) => {
  const classes = useStyles();

  const { setQ, data, order, orderBy } = useDatatables({
    rows: items,
    orderByDefault: "table_name",
    orderByRow: ["table_name"],
    pageSize: totalData,
    defaultOrder: "asc",
  });

  return (
    <Card className='mt-1'>
      <CardHeader
        titleTypographyProps={{ variant: "subtitle2" }}
        className={classes.cardHeader}
        action={
          <div className='mt-1'>
            <InputTextMaster
              name='name'
              label=''
              id='name'
              placeholder='Cari...'
              onChange={(e) => setQ(e.target.value)}
            />
          </div>
        }
        title={title}
        subheader={`${items.length} / ${totalData}  selected`}
      />

      <Divider />

      <List className={classes.list} dense component='div' role='list'>
        {stableSort(data, getComparator(order, orderBy)).map((value, index) => {
          const valueItem = value.table_id;
          const labelId = `transfer-list-all-item-${valueItem}-label`;

          return (
            <CheckboxListItem
              key={index}
              valueItem={valueItem}
              valueLabel={value.table_name}
              checked={value.checked}
              labelId={labelId}
              handleToggle={handleToggle}
            />
          );
        })}
      </List>
    </Card>
  );
};

const CheckboxListItem = ({
  valueItem,
  handleToggle,
  valueLabel,
  checked,
  labelId,
}) => {
  return (
    <ListItem
      role='listitem'
      button
      onClick={() =>
        handleToggle({
          table_id: valueItem,
          table_name: valueLabel,
          checked: checked,
        })
      }>
      <ListItemText
        id={labelId}
        style={{
          textTransform: "uppercase",
        }}
        primary={`${valueLabel}`}
      />
    </ListItem>
  );
};

export default TransferListUserAccess;
